import { Button, Card, Form, Input, message, Select } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../utils/apiClient";

const CreateCashierPage = () => {
  const { t } = useTranslation("auth");
  const { t: tPages } = useTranslation("pages");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [branches, setBranches] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    const load = async () => {
      try {
        const data = await apiRequest("/api/branches", { method: "GET" });
        setBranches(Array.isArray(data) ? data : []);
      } catch {
        setBranches([]);
      }
    };
    load();
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await apiRequest("/api/auth/cashier", {
        method: "POST",
        body: JSON.stringify({
          userName: values.userName,
          email: values.email,
          password: values.password,
          branchId: values.branchId,
        }),
      }, true);
      message.success(t("cashierCreated"));
      form.resetFields();
    } catch (error) {
      const msg = error?.data?.message || error?.message || t("somethingWentWrong");
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
          className="mb-4 -ml-2 flex items-center text-gray-600 hover:text-gray-800"
          aria-label="Go back"
        >
          {t("back")}
        </Button>
        <h1 className="text-2xl font-semibold mb-6 text-gray-800">
          {t("createCashierTitle")}
        </h1>
        <Card>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            label={t("username")}
            name="userName"
            help={t("createCashierUsernameHelp")}
            rules={[
              { required: true, message: t("usernameRequired") },
              { min: 2, max: 50, message: t("usernameLength") },
              {
                pattern: /^[a-zA-Z0-9_]+$/,
                message: t("usernamePattern"),
              },
            ]}
          >
            <Input placeholder={t("placeholderCashierUsername")} autoComplete="off" />
          </Form.Item>
          <Form.Item
            label={t("email")}
            name="email"
            rules={[{ required: true, type: "email", message: t("emailRequired") }]}
          >
            <Input type="email" placeholder={t("placeholderCashierEmail")} />
          </Form.Item>
          <Form.Item
            label={t("branch")}
            name="branchId"
            rules={[{ required: true, message: t("branchRequired") }]}
          >
            <Select
              placeholder={tPages("selectBranch")}
              showSearch
              optionFilterProp="label"
              options={branches.map((b) => ({
                value: b._id,
                label: `${b.name} (${b.location})`,
              }))}
            />
          </Form.Item>
          <Form.Item
            label={t("password")}
            name="password"
            rules={[{ required: true }, { min: 8 }]}
            help={t("passwordExtra")}
          >
            <Input.Password placeholder={t("placeholderCashierPassword")} autoComplete="new-password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              {t("createCashier")}
            </Button>
          </Form.Item>
        </Form>
      </Card>
      </div>
    </div>
  );
};

export default CreateCashierPage;
